import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Container, Nav } from 'react-bootstrap';

import { ReactComponent as Logo } from '../../../assets/images/logo.svg';

import { ReactComponent as FooterInstagram } from '../../../assets/images/footer-instagram.svg';
import { ReactComponent as FooterYoutube } from '../../../assets/images/footer-youtube.svg';
import { ReactComponent as FooterTiktok } from '../../../assets/images/footer-tiktok.svg';

const Footer = () => {
  return (
    <footer className="footer-top auth-footer">
      <div className='footer-top'>
        <Container>
          {/* <span>&copy; {new Date().getFullYear()} Map My App</span>
         */}
          <Row className='align-items-center'>
            <div className='footer-logo col-md-2'>
              <Logo />
            </div>
            <div className='footer-menu main-menu col-md-10'>
              <Nav>
                <Nav.Link as={NavLink}>
                  Blog
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Contact
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Jobs
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Comparison
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Community
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Invest
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Relocation Planner
                </Nav.Link>
              </Nav>
            </div>
          </Row>

        </Container>
      </div>

      <div className='footer-bottom'>
        <Container>
          <Row className='align-items-center'>
            <div className='col-sm-6'>
              <ul className='social-icons'>
                <li>
                  <NavLink as={NavLink}>
                    <FooterInstagram />
                  </NavLink>
                </li>
                <li>
                  <NavLink as={NavLink}>
                    <FooterYoutube />
                  </NavLink>
                </li>
                <li>
                  <NavLink as={NavLink}>
                    <FooterTiktok />
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className='col-sm-6'>

              <Nav>
                <Nav.Link as={NavLink}>
                  Terms & Conditions
                </Nav.Link>
                <Nav.Link as={NavLink}>
                  Privacy policy
                </Nav.Link>
              </Nav>
            </div>
          </Row>

        </Container>
      </div>
    </footer >
  );
};
export default Footer;
